export const formatMilliliters = (value: number) => `${value.toLocaleString()}ml`;
